// src/modules/app-views/_apps/appsindico/parkingSpots/pages/Document/actions/actionButton.js

const parkingSpotsDocumentActionButton = () => {
  return {
    action: null,
    hideButton: true,
    dropdownItems: [],
  };
};

export default parkingSpotsDocumentActionButton;
